import * as _4 from 'lodash4';
import { CommentServant } from '../../comments/servants/comment_servant';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../../global/builders/ap_planned_course_builder';
import {
  APProgramSlot,
  CourseGroupProgramSlot,
  IAPProgramSlotMeta,
  NCRProgramSlot,
  SingleCourseProgramSlot,
  WildcardProgramSlot
} from '../../global/builders/ap_program_slot_builder';
import { INVALID_ID } from '../../global/constants/ap_id_constants';

import { key } from 'core-ts-types';
import { Strategy } from 'utility-ts-strategy';
import { ICommentsDatasource } from '../../comments/datasources/comments_datasource';
import { APCourse } from '../../global/builders/ap_course_builder';
import {
  APCRGenericSlot,
  APGenericSlot,
  APGenericSlotBuilder,
  CourseGroupSlot,
  CourseSlot,
  NCRSlot,
  WildcardSlot
} from '../../global/builders/ap_generic_slot_builder';
import { PlannedCourseGroup } from '../../global/builders/planned_course_group_builder';
import { IAPAPMarkAsMetStatusDatasource } from '../../global/components/mark_as_met/datasources/mark_as_met_status_datasource';
import { IAPCoursesDatasource } from '../../global/datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../../global/datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../../global/datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../../global/datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../global/datasources/ap_terms_datasource';
import { APCourseServant } from '../../global/servants/ap_course_servant';
import { APMinGradeServant } from '../../global/servants/ap_min_grade_servant';
import { APPlannedCourseServant } from '../../global/servants/ap_planned_course_servant';
import { APProgramSlotServant } from '../../global/servants/ap_program_slot_servant';
import { APTermServant } from '../../global/servants/ap_term_servant';
import { APTermCourseDataQueryhelper } from './ap_term_course_data_query_helper';

export class APDegreeMapQueryHelper {
  constructor(
    private ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    private ngAPCoursesDatasource: IAPCoursesDatasource,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    private ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
    private ngAPTermsDatasource: IAPTermsDatasource,
    private ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource,
    private appConfigModel: any,
    private ngCommentsDatasource: ICommentsDatasource,
    private ngAPTermCourseDataQueryhelper: APTermCourseDataQueryhelper
  ) {}

  private getProgramSlots() {
    const allProgramSlotWithMeta = this.getAllProgramSlotsWithMetaInfo();
    const ProgramSlotsByReq = _4.partition(allProgramSlotWithMeta, 'is_devreq');
    return {
      allProgramSlotWithMeta,
      devReqProgramSlots: _4.head(ProgramSlotsByReq) as Array<SingleCourseProgramSlot & IAPProgramSlotMeta>,
      nonDevReqProgramSlots: _4.last(ProgramSlotsByReq)
    };
  }

  getAllProgramSlotsWithMetaInfo() {
    return this.ngAPProgramSlotDatasource.metasource().derived();
  }

  private getPlannedCourseInSlotByCourseId(
    plannedCoursesWithMeta: Array<APPlannedCourse & IAPPlannedCourseMeta>,
    courseId: string | number
  ) {
    return _4.find(plannedCoursesWithMeta, { course: courseId });
  }

  getPlannedCoursesWithMetaInfo() {
    return this.ngAPPlannedCoursesDatasource.metasource().derived();
  }

  getRelatedPlannedCourse(courseId: string | number) {
    const plannedCoursesWithMeta = this.getPlannedCoursesWithMetaInfo();
    const pastTermCoursesWithMeta = this.ngAPTermCourseDataQueryhelper.getPastTermCoursesWithMetaInfo();
    const plannedCourse = this.getPlannedCourseInSlotByCourseId(plannedCoursesWithMeta, courseId);
    return !_4.isEmpty(plannedCourse) ? plannedCourse : _4.find(pastTermCoursesWithMeta, { course: courseId });
  }

  getPlannedCourseByCourseIdAndTermId(courseId: string | number, termId: number) {
    const plannedCoursesWithMeta = this.getPlannedCoursesWithMetaInfo();
    const pastTermCoursesWithMeta = this.ngAPTermCourseDataQueryhelper.getPastTermCoursesWithMetaInfo();
    const plannedCourse = _4.find(plannedCoursesWithMeta, { course: courseId, term: termId }); // Should only find one
    return !_4.isEmpty(plannedCourse)
      ? plannedCourse
      : _4.find(pastTermCoursesWithMeta, { course: courseId, term: termId });
  }

  getPlannedCoursebyId(plannedCourseId: string | number) {
    const plannedCoursesWithMeta = this.getPlannedCoursesWithMetaInfo();
    const pastTermCoursesWithMeta = this.ngAPTermCourseDataQueryhelper.getPastTermCoursesWithMetaInfo();
    const plannedCourse = _4.find(plannedCoursesWithMeta, { id: plannedCourseId });
    return !_4.isEmpty(plannedCourse) ? plannedCourse : _4.find(pastTermCoursesWithMeta, { id: plannedCourseId });
  }

  getPlannedCourseInSlotBySlotId(slotId: key) {
    const plannedCoursesWithMeta = this.getPlannedCoursesWithMetaInfo();
    const plannedCourse = _4.filter(plannedCoursesWithMeta, { program_slot: slotId });
    const hasCourseBeenRescheduled = plannedCourse.length > 1;
    return hasCourseBeenRescheduled
      ? _4.last(plannedCourse)
      : _4.find(plannedCoursesWithMeta, { program_slot: slotId });
  }

  getDevReqProgramSlots() {
    return _4.sortBy(this.getProgramSlots().devReqProgramSlots, 'slot');
  }

  getNonDevReqProgramSlots() {
    return _4.sortBy(this.getProgramSlots().nonDevReqProgramSlots, 'slot');
  }

  getPlannedCourses(): APPlannedCourse[] {
    return this.ngAPPlannedCoursesDatasource.values();
  }

  getAllProgramSlots(): APProgramSlot[] {
    return this.ngAPProgramSlotDatasource.values();
  }

  getRequiredDataForDegreeMap() {
    const courses = this.ngAPCoursesDatasource.values();
    const allCourses = this.ngAPCoursesDatasource.metasource().derived();
    const plannedCourses: APPlannedCourse[] = this.getPlannedCourses();
    const plannedCoursesWithMeta = this.getPlannedCoursesWithMetaInfo();
    const allProgramSlots: APProgramSlot[] = this.getAllProgramSlots();
    const allProgramSlotWithMeta = this.getAllProgramSlotsWithMetaInfo();
    const plannedCourseGroups = this.ngAPTermCourseDataQueryhelper.getPlannedCourseGroups();
    return {
      courses,
      allCourses,
      plannedCourses,
      plannedCoursesWithMeta,
      allProgramSlots,
      allProgramSlotWithMeta,
      plannedCourseGroups
    };
  }

  buildDevReqGenericSlots() {
    const devReqProgramSlots = this.getDevReqProgramSlots();
    return _4.map(devReqProgramSlots, (programSlot) => {
      const type = programSlot.slot_type;
      const firstCourse = _4.head(programSlot._courses as APCourse[]);
      const relatedPlannedCourse = this.getPlannedCourseForDegreeMap(this.getRelatedPlannedCourse(firstCourse.id));
      const showMarkAsUnmetMenu = this.showMarkAsUnmetMenu(programSlot, relatedPlannedCourse);
      const { isCourseFlagged, flagComment } = this._getPlannedFlaggingInfo(relatedPlannedCourse);
      const isPlannedSomewhere =
        !_4.isEmpty(relatedPlannedCourse) && !APCourseServant.isLockedByStatus(relatedPlannedCourse.status);
      return APGenericSlotBuilder.build({
        title: `${firstCourse.cd} ${firstCourse.title}`,
        type,
        termId: _4.get(relatedPlannedCourse, 'term', INVALID_ID),
        course: firstCourse,
        plannedCourse: relatedPlannedCourse,
        programSlot,
        isCourseFlagged,
        flagComment,
        status: _4.get(relatedPlannedCourse, 'status', ''),
        shouldShowAddToTermMenu: !APCourseServant.isLockedByStatus(_4.get(relatedPlannedCourse, 'status', '')),
        hoverTemplate: APCourseServant.buildHoverTemplate(firstCourse),
        isPlannedSomewhere,
        isLockedByStatus: relatedPlannedCourse && APCourseServant.isLockedByStatus(relatedPlannedCourse.status),
        isDragEnabled: _4.isEmpty(relatedPlannedCourse),
        isPlanned: !_4.isEmpty(relatedPlannedCourse),
        credits: firstCourse.credits,
        disableSlot: !!relatedPlannedCourse || showMarkAsUnmetMenu,
        showMarkAsMetMenu: this.showMarkAsMetMenu(programSlot, relatedPlannedCourse),
        showMarkAsUnmetMenu
      });
    });
  }

  getPlannedCourseForCourseSlotInDegreeMap(programSlot: SingleCourseProgramSlot & IAPProgramSlotMeta) {
    if (APProgramSlotServant.isProgramSlotMET(programSlot)) {
      return {} as APPlannedCourse & IAPPlannedCourseMeta;
    }
    const firstCourse = _4.head(programSlot._courses as APCourse[]);
    const plannedCourseInSlot = this.getPlannedCourseInSlotBySlotId(programSlot.id);
    const plannedCourse = !_4.isEmpty(plannedCourseInSlot)
      ? plannedCourseInSlot
      : this.getRelatedPlannedCourse(firstCourse.id);
    return this.getPlannedCourseForDegreeMap(plannedCourse);
  }

  buildCourseGenericSlotForDegreeMap(programSlot: SingleCourseProgramSlot & IAPProgramSlotMeta): CourseSlot {
    const firstCourse = _4.head(programSlot._courses as APCourse[]);
    const plannedCourse = this.getPlannedCourseForCourseSlotInDegreeMap(programSlot);
    const showMarkAsUnmetMenu = this.showMarkAsUnmetMenu(programSlot, plannedCourse);
    const isCoursePlanned = !_4.isEmpty(plannedCourse);
    const { isCourseFlagged, flagComment } = this._getPlannedFlaggingInfo(plannedCourse);
    const minGradeFeature = this.appConfigModel.isFeatureEnabled('academicplan-program_slot_min_grade');
    const isMinGradeMet = APMinGradeServant.isMinGradeMet(programSlot, plannedCourse, minGradeFeature);
    return APGenericSlotBuilder.build({
      title: `${firstCourse.cd} ${firstCourse.title}`,
      type: 'COURSE',
      termId: _4.get(plannedCourse, 'term', INVALID_ID),
      course: firstCourse,
      isCourseFlagged,
      flagComment,
      plannedCourse,
      programSlot,
      status: '',
      isLockedByStatus: isCoursePlanned ? APCourseServant.isLockedByStatus(plannedCourse.status) : false,
      isDragEnabled: !isCoursePlanned || this.showCourseAddToTermMenu(programSlot, isCoursePlanned, plannedCourse),
      shouldShowAddToTermMenu: this.showCourseAddToTermMenu(programSlot, isCoursePlanned, plannedCourse),
      isMinGradeMet,
      isCourseCompleted: this.isCourseCompleted(plannedCourse),
      isPlanned: isCoursePlanned,
      credits: 0,
      hoverTemplate: APCourseServant.buildHoverTemplate(firstCourse),
      isLockedByAdvisor: _4.get(plannedCourse, 'is_locked', false),
      isPlannedSomewhere: isCoursePlanned ? APCourseServant.isLockedByStatus(plannedCourse.status) : false,
      disableSlot: isCoursePlanned || showMarkAsUnmetMenu,
      showMarkAsMetMenu: this.showMarkAsMetMenu(programSlot, plannedCourse),
      showMarkAsUnmetMenu,
      showGradeBadge: minGradeFeature && _4.get(programSlot, 'min_grade_point', null) !== null
    });
  }

  showCourseAddToTermMenu(programSlot: APProgramSlot, isCoursePlanned: boolean, plannedCourse: APPlannedCourse) {
    const minGradeFeature = this.appConfigModel.isFeatureEnabled('academicplan-program_slot_min_grade');
    const minGradeMet = APMinGradeServant.isMinGradeMet(programSlot, plannedCourse, minGradeFeature);
    const slotStatusEmpty = _4.isEmpty(programSlot.status);
    if (slotStatusEmpty || (this.isCourseCompleted(plannedCourse) && !minGradeMet)) {
      return true;
    }
    return !isCoursePlanned || !APCourseServant.isLockedByStatus(plannedCourse.status);
  }

  isCourseCompleted(plannedCourse: APPlannedCourse) {
    return _4.includes(['COMPLETED'], _4.get(plannedCourse, 'status', ''));
  }

  buildNCRGenericSlotForDegreeMap(programSlot: NCRSlot['programSlot']) {
    const title = `${!_4.isEmpty(programSlot.desc) ? programSlot.desc : programSlot.course_group}`;
    const NCRPlannedCourseGroup = _4.find(this.ngAPPlannedCourseGroupDatasource.values(), {
      program_slot: programSlot.id
    });
    const status = _4.isEmpty(NCRPlannedCourseGroup) ? 'DEFAULT' : 'PLANNED';
    const isPlanned = !_4.isEmpty(NCRPlannedCourseGroup);
    const showMarkAsUnmetMenu = this.showMarkAsUnmetMenu(programSlot, undefined, NCRPlannedCourseGroup);
    return APGenericSlotBuilder.build({
      title,
      type: 'NCR',
      termId: INVALID_ID,
      instructions: programSlot.instructions,
      status,
      isPlanned,
      isDragEnabled: !isPlanned,
      programSlot,
      plannedCourseGroup: NCRPlannedCourseGroup,
      disableSlot: isPlanned || showMarkAsUnmetMenu,
      showMarkAsMetMenu: this.showMarkAsMetMenu(programSlot, undefined, NCRPlannedCourseGroup),
      showMarkAsUnmetMenu
    });
  }

  buildWildcardGenericSlotForDegreeMap(programSlot: WildcardProgramSlot & IAPProgramSlotMeta) {
    const plannedCourseInSlot = this.getPlannedCourseInSlotBySlotId(programSlot.id);
    const title = !!plannedCourseInSlot
      ? `${plannedCourseInSlot._course.cd} ${plannedCourseInSlot._course.title}`
      : `${!_4.isEmpty(programSlot.desc) ? programSlot.desc : programSlot.course_group}`;
    const _plannedCourse = this.getPlannedCourseForDegreeMap(plannedCourseInSlot);
    const wildcardPlannedCourseGroup = _4.find(this.ngAPPlannedCourseGroupDatasource.values(), {
      program_slot: programSlot.id
    });
    const groupGenericSlots = this.constructGroupGenericSlots(programSlot, plannedCourseInSlot);
    const wildcardCoursePlanned = !!_plannedCourse;
    const showMarkAsUnmetMenu = this.showMarkAsUnmetMenu(programSlot, _plannedCourse, wildcardPlannedCourseGroup);
    const { isCourseFlagged, flagComment } = this._getPlannedFlaggingInfo(_plannedCourse);

    return APGenericSlotBuilder.build({
      title,
      type: 'WILDCARD',
      termId: _4.get(_plannedCourse, 'term', _4.get(wildcardPlannedCourseGroup, 'term', INVALID_ID)),
      course: wildcardCoursePlanned ? _plannedCourse._course : undefined,
      plannedCourse: _plannedCourse,
      instructions: programSlot.instructions,
      isPlaceHolder: false,
      plannedCourseGroup: wildcardPlannedCourseGroup,
      programSlot,
      status: wildcardCoursePlanned && _plannedCourse.status,
      isCourseFlagged,
      flagComment,
      genericSlots: [groupGenericSlots[0]],
      isLockedByStatus: wildcardCoursePlanned ? APCourseServant.isLockedByStatus(_plannedCourse._course.status) : false,
      isDragEnabled: !_4.isEmpty(_plannedCourse),
      isPlanned: !_4.isEmpty(_plannedCourse) || !!wildcardPlannedCourseGroup,
      credits: wildcardCoursePlanned ? _plannedCourse._course.credits : 0,
      isPlannedInCurrentGroup: !!_plannedCourse,
      hoverTemplate: wildcardCoursePlanned ? APCourseServant.buildHoverTemplate(_plannedCourse._course) : undefined,
      isLockedByAdvisor: _4.get(_plannedCourse, 'is_locked', false),
      disableSlot: !!_plannedCourse || !!wildcardPlannedCourseGroup || showMarkAsUnmetMenu,
      showMarkAsMetMenu: this.showMarkAsMetMenu(programSlot, _plannedCourse, wildcardPlannedCourseGroup),
      showMarkAsUnmetMenu
    });
  }

  _getPlannedFlaggingInfo(plannedCourse: NonNullable<APCRGenericSlot['plannedCourse']>) {
    const noFlagAdded = {
      isCourseFlagged: false,
      flagComment: undefined
    };

    if (_4.isEmpty(plannedCourse)) {
      return noFlagAdded;
    }

    const flaggedCourses = _4.keyBy(
      CommentServant.getValidCourseComments(this.ngCommentsDatasource.metasource().derived()),
      'object_id'
    );
    const courseId = _4.get(plannedCourse, '_course.id', -1);
    const flagInfo = flaggedCourses[courseId];
    if (_4.isEmpty(flagInfo)) {
      return noFlagAdded;
    }
    const isCourseFlagged = _4.has(flaggedCourses, courseId);
    const flagCommentHoverTemplate = isCourseFlagged ? CommentServant.getHoverTemplate(flagInfo) : undefined;

    const flagComment = {
      comment: flagInfo.message,
      id: flagInfo.id,
      hoverTemplate: flagCommentHoverTemplate
    };

    return {
      isCourseFlagged,
      flagComment
    };
  }

  isMarkAsMetFeatureEnabled() {
    return this.appConfigModel.isFeatureEnabled('academicplan-mark_as_met');
  }

  showMarkAsUnmetMenu(
    programSlot: APProgramSlot,
    plannedCourse?: APPlannedCourse,
    plannedCourseGroup?: PlannedCourseGroup
  ): boolean {
    const markAsMetFeatureEnabled = this.isMarkAsMetFeatureEnabled();
    if (!markAsMetFeatureEnabled) {
      return false;
    }

    const statusEntry = _4.first(
      this.ngAPMarkAsMetStatusDatasource.query((slot) => slot.program_slot === programSlot.id)
    );

    if (statusEntry && statusEntry.status === 'MET') {
      return true;
    }

    const courseNotPlanned = !APProgramSlotServant.isNCRProgramSlot(programSlot) && _4.isEmpty(plannedCourse);
    if (courseNotPlanned) {
      return false;
    }
    const courseGroupNotPlanned =
      !APProgramSlotServant.isCourseProgramSlot(programSlot) && _4.isEmpty(plannedCourseGroup);
    if (courseGroupNotPlanned) {
      return false;
    }
    return APProgramSlotServant.isProgramSlotMET(programSlot);
  }

  showMarkAsMetMenu(
    programSlot: APProgramSlot,
    plannedCourse?: APPlannedCourse,
    plannedCourseGroup?: PlannedCourseGroup
  ): boolean {
    const markAsMetFeatureEnabled = this.isMarkAsMetFeatureEnabled();
    const minGradeFeature = this.appConfigModel.isFeatureEnabled('academicplan-program_slot_min_grade');
    const isDevCourse = APProgramSlotServant.isCourseProgramSlot(programSlot) && programSlot.is_devreq;
    const alreadyMarkedAsMet =
      !_4.isEmpty(this.ngAPMarkAsMetStatusDatasource.query((slot) => slot.program_slot === programSlot.id)) ||
      APProgramSlotServant.isProgramSlotMET(programSlot);

    const dontShowMarkAsMetMenu = !markAsMetFeatureEnabled || alreadyMarkedAsMet || isDevCourse;
    if (dontShowMarkAsMetMenu) {
      return false;
    }

    if (plannedCourse && !_4.isEmpty(plannedCourse)) {
      const isMinGradeMet = APMinGradeServant.isMinGradeMet(programSlot, plannedCourse, minGradeFeature);
      if (this.isCourseCompleted(plannedCourse) && !isMinGradeMet) {
        return true;
      }
    }
    const courseNotPlanned = !APProgramSlotServant.isNCRProgramSlot(programSlot) && _4.isEmpty(plannedCourse);
    if (courseNotPlanned) {
      return _4.isEmpty(plannedCourseGroup);
    }
    const courseGroupNotPlanned =
      !APProgramSlotServant.isCourseProgramSlot(programSlot) && _4.isEmpty(plannedCourseGroup);
    if (courseGroupNotPlanned) {
      return _4.isEmpty(plannedCourse);
    }

    return false;
  }

  buildCourseGroupGenericSlotForDegreeMap(programSlot: CourseGroupProgramSlot & IAPProgramSlotMeta) {
    const plannedCourseInSlot = this.getPlannedCourseInSlotBySlotId(programSlot.id);
    const title = !!plannedCourseInSlot
      ? `${_4.get(plannedCourseInSlot, '_course.cd', '')} ${_4.get(plannedCourseInSlot, '_course.title', '')}`
      : `${programSlot.desc}`;
    const _plannedCourse = this.getPlannedCourseForDegreeMap(plannedCourseInSlot);
    const groupGenericSlots = this.constructGroupGenericSlots(programSlot, plannedCourseInSlot);
    const plannedCourseGroup = this.ngAPTermCourseDataQueryhelper.getPlannedCourseGroup(programSlot.id);
    const isPlannedInCurrentGroup = !!_plannedCourse && _4.find(groupGenericSlots, { id: _plannedCourse._course.id });
    const firstCourse = _4.head(programSlot._courses as APCourse[]);
    const showMarkAsUnmetMenu = this.showMarkAsUnmetMenu(programSlot, _plannedCourse, plannedCourseGroup);
    const { isCourseFlagged, flagComment } = this._getPlannedFlaggingInfo(_plannedCourse);
    const minGradeFeature = this.appConfigModel.isFeatureEnabled('academicplan-program_slot_min_grade');
    const isLockedByStatus = !!_plannedCourse ? APCourseServant.isLockedByStatus(_plannedCourse.status) : false;
    return APGenericSlotBuilder.build({
      title,
      type: 'GROUP',
      termId: _4.get(_plannedCourse, 'term', _4.get(plannedCourseGroup, 'term', INVALID_ID)),
      courses: programSlot._courses as APCourse[],
      plannedCourse: _plannedCourse,
      isPlaceHolder: false,
      plannedCourseGroup,
      isCourseFlagged,
      flagComment,
      programSlot,
      instructions: '',
      status: '',
      firstCourse,
      genericSlots: _4.take(groupGenericSlots, Math.min(programSlot.total_courses, 10)),
      isLockedByStatus,
      isDragEnabled: !_4.isEmpty(_plannedCourse),
      isPlanned: !_4.isEmpty(_plannedCourse) || !!plannedCourseGroup,
      min_credits: programSlot.min_credits,
      max_credits: programSlot.max_credits,
      shouldShowAddToTermMenu: isLockedByStatus,
      isPlannedInCurrentGroup: !!isPlannedInCurrentGroup,
      hoverTemplate: APCourseServant.buildHoverTemplate(firstCourse),
      isLockedByAdvisor: _4.get(_plannedCourse, 'is_locked', false),
      disableSlot: !_4.isEmpty(_plannedCourse) || !!plannedCourseGroup || showMarkAsUnmetMenu,
      showMarkAsMetMenu: this.showMarkAsMetMenu(programSlot, _plannedCourse, plannedCourseGroup),
      showMarkAsUnmetMenu,
      showGradeBadge: minGradeFeature && _4.get(programSlot, 'min_grade_point', null) !== null
    });
  }

  getPlannedCourseStatusForDegreeMap(plannedCourse: APPlannedCourse) {
    const plannedCourseStatus = ''; // this does not include REGISTERED, WAITLISTED, SECTION_PICKED ...
    if (!plannedCourse) {
      return plannedCourseStatus;
    }

    const term = this.ngAPTermsDatasource.get(plannedCourse.term);
    const isRegistrationOpenForTerm = term && APTermServant.isRegistrationOpen(term);
    if (plannedCourse.status === 'SECTION_PICKED' && !isRegistrationOpenForTerm) {
      return plannedCourseStatus;
    }

    return plannedCourse.status;
  }

  getPlannedCourseForDegreeMap(
    plannedCourse: APPlannedCourse & IAPPlannedCourseMeta
  ): APPlannedCourse & IAPPlannedCourseMeta {
    if (!plannedCourse) {
      return plannedCourse;
    }
    return {
      ...plannedCourse,
      status: this.getPlannedCourseStatusForDegreeMap(plannedCourse)
    };
  }

  showGroupCourseToTermMenu(plannedCourse: APPlannedCourse, programSlot: APProgramSlot) {
    if (_4.isEmpty(plannedCourse)) {
      return true;
    }
    const minGradeFeature = this.appConfigModel.isFeatureEnabled('academicplan-program_slot_min_grade');
    return (
      this.isCourseCompleted(plannedCourse) &&
      !APMinGradeServant.isMinGradeMet(programSlot, plannedCourse, minGradeFeature)
    );
  }

  constructGroupGenericSlots(
    programSlot: Exclude<APGenericSlot['programSlot'], NCRProgramSlot>,
    plannedCourseInSlot: any = {},
    plannedCourse: any = {},
    flaggedCourses: any = {}
  ) {
    let courses;
    const isCourseGroup = programSlot.slot_type === 'GROUP';
    if (!isCourseGroup && !_4.isEmpty(plannedCourse)) {
      courses = _4.compact([plannedCourse._course]);
    } else {
      courses = programSlot._courses;
    }

    return _4.map(courses as APCourse[], (course) => {
      let relatedPlannedCourse = {} as any;
      if (!_4.isEmpty(plannedCourseInSlot) && plannedCourseInSlot.course === course.id) {
        relatedPlannedCourse = plannedCourseInSlot;
      }
      if (_4.isEmpty(relatedPlannedCourse)) {
        relatedPlannedCourse = this.getRelatedPlannedCourse(course.id);
      }

      const isLockedByAdvisor = _4.get(
        _4.find(this.getPlannedCoursesWithMetaInfo(), { course: course.id }),
        'is_locked',
        false
      );
      const isCourseFlagged = _4.has(flaggedCourses, course.id);
      const flagCommentHoverTemplate = isCourseFlagged
        ? CommentServant.getHoverTemplate(flaggedCourses[course.id])
        : undefined;
      return APGenericSlotBuilder.build({
        title: `${course.cd} ${course.title}`,
        type: 'COURSE',
        isLockedByAdvisor,
        termId: INVALID_ID,
        isCourseFlagged,
        flagComment: {
          comment: _4.get(flaggedCourses[course.id], 'message'),
          id: _4.get(flaggedCourses[course.id], 'id'),
          hoverTemplate: flagCommentHoverTemplate
        },
        programSlot: programSlot as SingleCourseProgramSlot & IAPProgramSlotMeta,
        course,
        plannedCourse: relatedPlannedCourse,
        status: '',
        isDragEnabled: true,
        isPlanned: !!relatedPlannedCourse,
        shouldShowAddToTermMenu: this.showGroupCourseToTermMenu(relatedPlannedCourse, programSlot),
        credits: course.credits,
        hoverTemplate: _4.isEmpty(plannedCourse)
          ? APCourseServant.buildHoverTemplate(course)
          : APPlannedCourseServant.buildPlannedCourseHoverTemplate(relatedPlannedCourse, course),
        isPlannedSomewhere: relatedPlannedCourse && !!relatedPlannedCourse.id,
        isPlannedInCurrentGroup: plannedCourse.course === course.id,
        disableSlot: !!relatedPlannedCourse
      });
    });
  }

  buildNonDevGenericSlots() {
    const nonDevReqProgramSlots = this.getNonDevReqProgramSlots();
    return _4.map(nonDevReqProgramSlots, (programSlot) => {
      if (APProgramSlotServant.isCourseProgramSlot(programSlot)) {
        return this.buildCourseGenericSlotForDegreeMap(programSlot);
      }
      if (APProgramSlotServant.isWildcardProgramSlot(programSlot)) {
        return this.buildWildcardGenericSlotForDegreeMap(programSlot);
      }
      if (APProgramSlotServant.isCourseGroupProgramSlot(programSlot)) {
        return this.buildCourseGroupGenericSlotForDegreeMap(programSlot);
      }
      if (APProgramSlotServant.isNCRProgramSlot(programSlot)) {
        return this.buildNCRGenericSlotForDegreeMap(programSlot);
      }
      return this.buildCourseGenericSlotForDegreeMap(programSlot);
    });
  }
}

angular.module('capability-ng-academic-planner').service('ngAPDegreeMapQueryHelper', APDegreeMapQueryHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_degree_map_query_helper.ts